module.exports = __webpack_public_path__ + "static/media/q1-scientific.dff33f7c.png";